// extracted by mini-css-extract-plugin
export default {"mySwiper":"Carousel_mySwiper__vQTKN","slide":"Carousel_slide__ozQ3I"};